import React, { useEffect, useState } from "react";
import CourseInput from "./courseInput";
import SaveChanges from "./saveChanges";
import { useNavigate, useParams } from "react-router-dom";
import WhiteLoading from "./whiteLoading";
import Info from "./info";
import PrevCourseSelect from "./prevCourseSelect";
import PrevEvalSelect from "./PrevEvalSelect";

const ImportEval = ({ updateIsImporting, prevCourses, prevEvals }) => {
    const navigate = useNavigate();
    const [text, setText] = useState("Import an evaluation below");
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);
    const { courseCode } = useParams();
    const [form, setForm] = useState({
        courseCode: courseCode,
        prevCourseCode: '',
        prevAssessmentCode: '',
        newStart: null,
        newEnd: null
    })

    const resetForm = () => {
        setForm({
            courseCode: courseCode,
            prevCourseCode: null,
            prevAssessmentCode: null,
            newStart: null,
            newEnd: null
        })

        updateIsImporting(false);
    }

    const submitForm = async (e) => {
        e.preventDefault();

        if (!(form.prevCourseCode)) {
            setText("Please select a previous course")
            return
        }

        if (!(form.prevAssessmentCode)) {
            setText("Please select a previous evaluation")
            return
        }        

        const input_data = {
            ...form,
            newStart: (new Date(form.newStart)).toISOString(),
            newEnd: (new Date(form.newEnd)).toISOString()
        }

        try {
            setRequestLifeCycle(true);
            const url = process.env.REACT_APP_COURSE_API_URL + '/import-evaluation';
            const urlOptions = {
                method: "POST",
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(input_data)
            }

            const response = await fetch(url, urlOptions);
            const data = await response.json();

            if (response.status === 200) {
                navigate(`/${courseCode}/${data.assessmentCode}/edit`)
            } else if (response.status === 404) {
                setText(data.detail);
            } else {
                alert("Status Code: " + response.status + " Error: " + data.detail);
            }

        } catch(error) {
            console.log(error);
            setText("Error: " + error.message);
        } finally {
            setRequestLifeCycle(false);
        }
    }

    const updateForm = (key, value) => {
        setForm((prev) => {
            return {
                ...prev,
                [key]: value
            }
        })
    }

    const updateStart = (newValue) => {
        updateForm("newStart", newValue);
    }

    const updateEnd = (newValue) => {
        updateForm("newEnd", newValue);
    }

    const updatePrevCourseCode = (newValue) => {
        updateForm("prevCourseCode", newValue);
    }

    const updatePrevEvalCode = (newValue) => {
        updateForm("prevAssessmentCode", newValue);
    }

    return (
        <>
            <div className="black-back" onClick={ () => {updateIsImporting(false)} }>

            </div>
            <div className="add-a-course-form-container">
                <div className="add-a-course-form-content-container">
                    <form className="form-width">
                        <div className="add-course-title">
                            Import An Evaluation
                        </div>
                        <div className="account-settings-content">
                            <div className="required-container">
                                <div className="required">
                                    *
                                </div> Required Field
                            </div>   
                            <div className="banner">
                                {
                                    requestLifeCycle 

                                    ?
                                    
                                    <>
                                        <WhiteLoading />
                                    </>

                                    :

                                    <div className="banner-info">
                                        <Info />
                                        { text }
                                    </div>

                                }
                            </div>                            
                            <PrevCourseSelect prevCourseCode={form.prevCourseCode} prevCourses={prevCourses} handleChange={updatePrevCourseCode}/>
                            {
                                form.prevCourseCode && (
                                    <PrevEvalSelect prevEvalCode={form.prevAssessmentCode} prevEvals={prevEvals[form.prevCourseCode]} handleChange={updatePrevEvalCode}/>
                                )
                            }                            
                            <CourseInput value={form.newStart} updateValue={updateStart} top={"New Available From"} type={"datetime-local"} required={true} autoComplete={"off"} placeholder={"Select date and time"}/>
                            <CourseInput value={form.newEnd} updateValue={updateEnd} top={"New Available Until"} type={"datetime-local"} required={true} autoComplete={"off"} placeholder={"Select date and time"}/>                          
                            <SaveChanges left="Cancel" right={{ small : "Import", large : "Import Evaluation" }} resetForm={resetForm} submitForm={submitForm}/> 
                        </div>
                    </form> 
                </div>
            </div>
        </>
    );
}

export default ImportEval;